import { createTheme } from "@mui/material/styles";
/**
 * theme
 *
 * تنظیمات و شخصی‌سازی تم برای MUI (Material-UI).
 * شامل پالت رنگ‌ها، تایپوگرافی و استایل‌های سفارشی برای کامپوننت‌ها.
 *
 * @returns Theme - تم سفارشی MUI
 */

declare module "@mui/material/styles" {
  interface Palette {
    linkColor: {
      main: string;
    };
  }

  interface PaletteOptions {
    linkColor?: {
      main: string;
    };
  }
}
const theme = createTheme({
  palette: {
    primary: {
      main: "#EB6440",
    },
    secondary: {
      main: "#FFC107",
    },
    background: {
      default: "#000",
    },
    backgroundBox: {
      default: "#2C2C2C",
    },
    linkColor: {
      main: "#3687FF",
    },
    text: {
      primary: "#ffffff",
      secondary: "#cccccc",
    },
  },
  typography: {
    fontFamily: "vaziriFont, Roboto, Arial, sans-serif",
    allVariants: {
      color: "#ffffff",
    },
    h6: {
      fontWeight: 600,
      fontSize: "20px",
    },
    subtitle1: { fontSize: "32px", color: "#fff", fontWeight: "Bold" },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
        },
      },
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#CFCFCF",
          height: "48px",
          borderRadius: "10px",
          color: "#fff",

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#EB6440",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#EB6440",
          },
        },
        input: {
          color: "#fff",
        },
        notchedOutline: {
          borderColor: "#fff",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#ccc",
          "&.Mui-focused": {
            color: "#EB6440",
          },
        },
      },
    },
  },
});

export default theme;
